<script setup lang="ts">
import type { LOCALE } from "core/interfaces";

import { navigateToItemDetails } from "~/common/helpers/navigate-to-item-details";
import { useShopStore } from "~/stores/shop";

const { locale } = useI18n();
const shopStore = useShopStore();

const navigateToItemDetailsBound = navigateToItemDetails.bind(this, locale.value as LOCALE, shopStore.components.kinds);
</script>

<template>
	<section class="flex flex-col items-center">
		<h2 class="text-3xl uppercase font-medium">
			{{ $t('bestSellingProducts') }}
		</h2>
		<div class="mt-7 grid gap-6 grid-cols-4 md:grid-cols-2 sm:grid-cols-2 xs:grid-cols-1">
			<ItemCard
				v-for="item in shopStore.bestSellingProducts"
				:key="item.id"
				:item="item"
				@click="navigateToItemDetailsBound(item)"
			/>
		</div>
		<HomeButtonLink class="mt-9" :link="{path: '/shop'}">
			{{ $t('seeAllProducts') }}
		</HomeButtonLink>
	</section>
</template>
